import React from 'react'
import { MoveToListButton } from 'components/Shared/MuiTable/ActionButton'
import { useNewTranslation, NewTrans } from 'hooks/index'
import InfoTooltip from 'components/InfoTooltip'
import Divider from 'components/Shared/Divider'
import styled from 'particles/themes/styled'
import Text from 'particles/Text'
import RectangleButton from 'particles/Button/RectangleButton'

interface PriorityListHeaderBarProps {
    onClickMoveBackToPending?: any
    onClickMoveBackToWaitlist: any
    onClickSaveChanges: any
    disableMoveBackToPending?: boolean
    disableMoveBackToWaitlist?: boolean
    disableSaveChanges?: boolean
    isSubmitType?: boolean
    hideToolbar?: boolean
    className?: string
}

const PriorityListHeaderBar: React.FC<PriorityListHeaderBarProps> = ({
    onClickMoveBackToPending,
    onClickMoveBackToWaitlist,
    onClickSaveChanges,
    disableMoveBackToPending = false,
    disableMoveBackToWaitlist = false,
    disableSaveChanges = false,
    isSubmitType,
    hideToolbar,
    className,
}) => {
    const [newT] = useNewTranslation()
    return (
        <div className={className}>
            <div className="table-title-block">
                <Text scale="H4" color="primary">
                    {newT('submission.review.priorityListTableTitle', 'Priority List')}
                </Text>
                <InfoTooltip
                    label={
                        <NewTrans i18nKey={'statusLabel.priorityListTooltipDescription'}>
                            <Text scale="caption400" color="primaryInverse" style={{ marginBottom: 16 }}>
                                The priority list allows you to manually arrange Partiposters in your preferred approval
                                order. Partiposters in this list will automatically be approved in order whenever a
                                registration slot becomes available.
                            </Text>
                            <Text scale="caption400" color="primaryInverse">
                                You can move Partiposters from the waitlist to the priority list to enable this
                                function. Alternatively, you can empty the priority list by moving Partiposters back to
                                the waitlist or back to Pending status.
                            </Text>
                        </NewTrans>
                    }
                    iconColor="primary"
                />
            </div>
            <Divider className="divider" />
            {!hideToolbar && (
                <div className="tool-bar">
                    <div className="move-list-buttons">
                        {onClickMoveBackToPending && (
                            <MoveToListButton
                                onClick={onClickMoveBackToPending}
                                isDisable={disableMoveBackToPending}
                                text={newT('button.moveBackToPending')}
                                iconSize="20px"
                            />
                        )}
                        {onClickMoveBackToWaitlist && (
                            <MoveToListButton
                                onClick={onClickMoveBackToWaitlist}
                                isDisable={disableMoveBackToWaitlist}
                                text={newT('button.moveBackToWaitlist', 'Move back to waitlist')}
                                isWaitList
                            />
                        )}
                    </div>

                    <RectangleButton
                        form="filled"
                        size="s"
                        color="neutral"
                        label={newT('button.saveChanges', 'Save Changes')}
                        isDisabled={disableSaveChanges}
                        onClick={onClickSaveChanges}
                        type={isSubmitType ? 'submit' : undefined}
                    />
                </div>
            )}

            <Text>{newT('submission.review.priorityListInstruction', 'Prioritise only up to 20 Partiposters')}</Text>
        </div>
    )
}

export default styled(PriorityListHeaderBar)`
    display: flex;
    flex-direction: column;
    .table-title-block {
        display: flex;
        margin: 8px 0 19px 0;
        align-items: center;
    }
    .tool-bar,
    .move-list-buttons {
        display: flex;
        justify-content: space-between;
    }
    .tool-bar {
        margin-bottom: 12px;
    }
    .divider {
        margin-bottom: 8px;
    }
`
